// src/blocks/icon/SVGs/pause.tsx
import * as React from "react";
import { jsx, jsxs } from "react/jsx-runtime";
var PauseSVG = ({
  title = "Pause Icon",
  width = 16,
  height = 16,
  ...props
}) => {
  const titleId = React.useId();
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      width,
      height,
      "aria-labelledby": titleId,
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        /* @__PURE__ */ jsx("title", { id: titleId, children: title }),
        /* @__PURE__ */ jsx("path", { d: "M4 0L4 16", stroke: "currentColor", strokeWidth: "4" }),
        /* @__PURE__ */ jsx("path", { d: "M12 0L12 16", stroke: "currentColor", strokeWidth: "4" })
      ]
    }
  );
};
var pause_default = PauseSVG;

export {
  pause_default
};
